import { loadEntity } from "src/pages/EntityCardPage/apiEntityCard";
import { ZEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";

const entityRequestCache: Record<ZUid, Promise<ZEntity>> = {};
export const getEntityCachedRequest = async (eId: ZUid): Promise<ZEntity> => {
  if (entityRequestCache[eId]) return entityRequestCache[eId]!;
  entityRequestCache[eId] = loadEntity(eId);
  return entityRequestCache[eId]!;
};
